// Copyright (c) 2022 by Move Closer

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum AllowedAttributes {
  AdditionalDescription = 'additionalDescription',
  Application = 'application', // Day, Night, Day&Night
  AromaticNote = 'aromaticNote',
  BoxException = 'box_exception',
  Brand = 'brand',
  BrandUrl = 'brand_url',
  Capacity = 'capacity',
  Certifications = 'certifications',
  CertCrueltyFree = 'certificationCrueltyFree',
  CertFSC = 'certificationFSC',
  CertVegan = 'certificationVegan',
  Color = 'color',
  ColorName = 'colorName',
  Composition = 'composition',
  Consistency = 'consistency',
  ExtendedDescription = 'extendedDescription',
  ForWhom = 'forWhom',
  GiftsSku = 'giftsSku',
  Gramature = 'gramature',
  HasFreeDelivery = 'hasFreeDelivery',
  HasGift = 'hasGift',
  HasSamples = 'hasSamples',
  IsBestOffer = 'isBestOffer',
  IsBestseller = 'isBestseller',
  IsFaF = 'isFaF',
  IsGift = 'isGift',
  IsNatural = 'isNatural',
  IsNew = 'isNew',
  IsPresale = 'isPresale',
  IsSale = 'isSale',
  IsSample = 'isSample',
  IsSponsored = 'isSponsored',
  KindOfProduct = 'kindOfProduct',
  LoyaltyPrograms = 'loyaltyPrograms',
  MainCategory = 'mainCategory',
  MainCategoryUrl = 'mainCategoryUrl',
  MainDescription = 'mainDescription',
  Operation = 'operation',
  PackageAmount = 'package_amount',
  Reformance = 'performance',
  PriceRange = 'priceRange',
  Producer = 'producer',
  ProductLine = 'productLine',
  SamplesSku = 'samplesSku',
  SellableQuantity = 'sellableQuantity',
  Size = 'size', // E.g. 30 ml
  SkinType = 'skinType',
  SnippetId = 'snippetId',
  SpfFilter = 'spfFilter',
  TaxClassId = 'taxClassId',
  Type = 'type',
  VariantVolume = 'variantVolume',
  VolumeName = 'volumeName',
  Volume = 'volume',
  WeightName = 'weightName'
}
